<div class="classification-container" *ngIf="!isLoadingLabels">
	<div class="dotted-input-container" *ngIf="!hideField || (hideField && !hideField.includes('serviceType'))">
		<span>{{ labels.lbl_chamado_tipo_servico }} <ng-container *ngIf="requiredField.includes('serviceType')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('serviceType') }"
			[disabled]="disabled || (lockField && lockField.includes('serviceType'))"
			(change)="setServiceType($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<ng-container *ngFor="let serviceType of availableClassification.serviceType">
				<option
					[value]="serviceType.id"
					[selected]="selectedClassification.serviceType[0] && serviceType.id === selectedClassification.serviceType[0].id"
					*ngIf="!hideServiceType || !hideServiceType.includes(serviceType.id)">
					{{ labels[serviceType.label] ? labels[serviceType.label] : serviceType.name }}
				</option>
			</ng-container>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.serviceType[0] &&
			availableClassification.scope.length != 0 &&
			(!hideField || (hideField && !hideField.includes('scope')))
		">
		<span>{{ labels.lbl_geral_competencia }} <ng-container *ngIf="requiredField.includes('scope')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('scope') }"
			[disabled]="disabled || (lockField && lockField.includes('scope'))"
			(change)="setScope($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="scope.id"
				[selected]="selectedClassification.scope[0] && selectedClassification.scope[0].id == scope.id"
				*ngFor="let scope of availableClassification.scope">
				{{ labels[scope.label] ? labels[scope.label] : scope.name }}
			</option>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.scope[0] &&
			availableClassification.category.length != 0 &&
			(!hideField || (hideField && !hideField.includes('category')))
		">
		<span>{{ labels.lbl_asset_category }} <ng-container *ngIf="requiredField.includes('category')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('category') }"
			[disabled]="disabled || (lockField && lockField.includes('category'))"
			(change)="setCategory($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="category.id"
				[selected]="selectedClassification.category[0] && selectedClassification.category[0].id == category.id"
				*ngFor="let category of availableClassification.category">
				{{ labels[category.label] ? labels[category.label] : category.name }}
			</option>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.category[0] &&
			availableClassification.topic.length != 0 &&
			(!hideField || (hideField && !hideField.includes('topic')))
		">
		<span>{{ labels.lbl_geral_topico }} <ng-container *ngIf="requiredField.includes('topic')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('topic') }"
			[disabled]="disabled || (lockField && lockField.includes('topic'))"
			(change)="setTopic($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="topic.id"
				[selected]="selectedClassification.topic[0] && selectedClassification.topic[0].id == topic.id"
				*ngFor="let topic of availableClassification.topic">
				{{ labels[topic.label] ? labels[topic.label] : topic.name }}
			</option>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.topic[0] &&
			availableClassification.solutionArea.length != 0 &&
			(!hideField || (hideField && !hideField.includes('solutionArea')))
		">
		<span>{{ labels.lbl_geral_grupo }} <ng-container *ngIf="requiredField.includes('solutionArea')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('solutionArea') }"
			[disabled]="disabled || (lockField && lockField.includes('solutionArea'))"
			(change)="setSolutionArea($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="solutionArea.id"
				[selected]="selectedClassification.solutionArea[0] && selectedClassification.solutionArea[0].id == solutionArea.id"
				*ngFor="let solutionArea of availableClassification.solutionArea">
				{{ labels[solutionArea.label] ? labels[solutionArea.label] : solutionArea.name }}
			</option>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.solutionArea[0] &&
			availableClassification.changeType.length != 0 &&
			(!hideField || (hideField && !hideField.includes('changeType')))
		">
		<span>{{ labels.lbl_rep_tipo_change }} <ng-container *ngIf="requiredField.includes('changeType')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('changeType') }"
			[disabled]="disabled || (lockField && lockField.includes('changeType'))"
			(change)="setChangeType($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="changeType.id"
				[selected]="selectedClassification.changeType[0] && changeType.id === selectedClassification.changeType[0].id"
				*ngFor="let changeType of availableClassification.changeType">
				{{ labels[changeType.label] ? labels[changeType.label] : changeType.name }}
			</option>
		</select>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.solutionArea[0] &&
			availableClassification.severity.length != 0 &&
			(!hideField || (hideField && !hideField.includes('severity')))
		">
		<span>{{ labels.lbl_geral_severidade }} <ng-container *ngIf="requiredField.includes('severity')">*</ng-container></span>
		<select
			[ngClass]="{ 'required-alert': alertField && alertField.includes('severity') }"
			[disabled]="disabled || (lockField && lockField.includes('severity'))"
			(change)="setSeverity($event.target.value)">
			<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
			<option
				[value]="severity.id"
				[selected]="selectedClassification.severity[0] && severity.id === selectedClassification.severity[0].id"
				*ngFor="let severity of availableClassification.severity">
				{{ labels[severity.label] ? labels[severity.label] : severity.name }}
			</option>
		</select>
	</div>

	<cpi-dot-bounce-loading-effect
		[color]="'var(--primary-color-1)'"
		*ngIf="
			isLoadingServiceType ||
			isLoadingScope ||
			isLoadingCategory ||
			isLoadingTopic ||
			isLoadingSolutionArea ||
			isLoadingSeverity ||
			isLoadingChangeType
		"></cpi-dot-bounce-loading-effect>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
